import { FC } from 'react';
import { Icon, Icons, Tooltip, TooltipProps, Typography } from '../../../../stories/atoms';

type InfoTooltipIconProps = {
  tooltipText?: string;
  testId: string;
  position?: TooltipProps['position'];
};

export const InfoTooltipIcon: FC<InfoTooltipIconProps> = ({ tooltipText, testId, position = 'bottom' }) => {
  if (!tooltipText) return null;

  return (
    <Tooltip text={<Typography color="white">{tooltipText}</Typography>} position={position}>
      <span tabIndex={0} role="button" aria-label={tooltipText}>
        <Icon data-testid={testId} icon={Icons.INFO} size="small" margin={[0, 0, 0, 1]} />
      </span>
    </Tooltip>
  );
};
